// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import gray from '@tcp/core/styles/themes/colors/gray';
import blue from '@tcp/core/styles/themes/colors/blue';

const styleButton = {
  buttonTextColorSPC: {
    color: blue[900],
  },
  buttonTextColor: {
    color: gray[700],
  },
};

const getPageStyle = (props) => {
  const { fullPage, isOTpScreenEnabled, showNewOtpScreen } = props;

  if (fullPage && isOTpScreenEnabled && showNewOtpScreen) {
    return 'max-width:600px;margin:0 auto; display: flex;align-items: center; justify-content: center;';
  }
  if (fullPage) {
    return 'max-width:450px;margin:0 auto;';
  }
  return '';
};

const styles = css`
  ${(props) => getPageStyle(props)}
  .login-button-test-class {
    ${(props) => (props.fullPage ? 'width: 210px;display: block;margin: 10px auto;' : '')}
  }
  .elem-pl-LRG {
    padding-left: 15px;
  }
  .elem-pr-LRG {
    padding-right: 15px;
  }
  .checkoutForm {
    padding-left: 0px;
    padding-right: 0px;
    margin: 0 auto;
    @media ${(props) => props.theme.mediaQuery.largeOnly} {
      ${(props) => !props.isShowOTPInputScreen && 'padding-left: 74px;padding-right: 74px;'}
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 80%;
    }
  }
  .border {
    width: 91%;
    ${(props) =>
      props.variation === 'checkout'
        ? `
        &::before{
        content: '';
        display: block;
        border-top: 2px solid ${props.theme.colorPalette.blue.C900};
        width: 50%;
        margin-left:25%;
        height: 2px;
        text-align:center;
        padding-bottom:27px;
        }`
        : `${props.fullPage ? '' : `border-top: 1px solid ${props.theme.colors.BORDER.BLUE};`}`};
    margin: 0 auto;
    p {
      max-width: 227px;
      margin: 0 auto;
      ${(props) =>
        props.fullPage
          ? `max-width:260px;font-size:14px;font-weight: ${props.theme.typography.fontWeights.semibold};`
          : ''}
    }
  }
  .create-acc-cta {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    ${(props) => (props.fullPage ? 'width: 210px;display: block;margin: 10px auto;' : '')}
    ${(props) =>
      props.variation === 'checkout'
        ? `border:1px solid ${props.theme.colorPalette.gray[2400]};color:${props.theme.colorPalette.gray[800]}`
        : ''};
  }
  .border.elem-pt-MED {
    ${(props) => (props.variation === 'checkout' ? 'padding-top:0px' : 'padding-top: 27px;')}
  }
  .border.elem-pt-LRG {
    padding-bottom: 27px;
  }
  .password-required-msg {
    .reset-password-heading,
    .reset-password-list {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
      font-weight: ${(props) => props.theme.fonts.fontWeight.normal};
    }
    .reset-password-note {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy1}px;
      text-align: center;
    }

    li:before {
      content: '-';
      text-indent: -5px;
    }
  }
  .remember-me-text {
    ${(props) => (props.fullPage ? 'font-size:12px;' : '')}
  }
  .remember-me-sub-text {
    ${(props) => (props.fullPage ? 'font-size:12px;' : '')}
  }
  .remember-me-checkbox {
    ${(props) => (props.fullPage ? 'margin:40px 0;' : '')}
  }
  ${(props) =>
    props.fullPage
      ? '.rightAlignedContent {width: auto;top: 20px;.reset-tooltip {display: none;}a {font-size: 16px;}}'
      : ''}
  .underline {
    border-bottom: 2px solid ${(props) => props.theme.colorPalette.blue[200]};
    width: 150px;
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.REG} auto
      ${(props) => props.theme.spacing.ELEM_SPACING.XXL} auto;
  }
  .loginPageSpacing {
    margin-top: ${(props) => {
      return props.isLoginWithOTPEnabled && !props.fromGuestFav && !props.fromPlccICLogin && '70px';
    }};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-top: ${(props) => props.isOTpScreenEnabled && `16px;`};
    }
  }
  @media (max-width: 430px) {
    .loginPageSpacing {
      margin-top: ${(props) =>
        props.isLoginWithOTPEnabled && !props.fromGuestFav && !props.fromPlccICLogin && '100px'};
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        margin-top: ${(props) => props.isOTpScreenEnabled && `16px;`};
      }
    }
  }
`;

export default styles;
export { styleButton };
